import { Injectable } from '@angular/core';
import { FiBackendService } from '../../../fi-backend/fi-backend.service';
import { LoadingService } from '../../../fi-loading/loading.service';
import {
    IChecklistV2ReportParameter,
    IChecklist2ReportContainer,
    IChecklist2ReportData,
    IChecklist2ReportAttachmentParameter,
    ICheckpoint2AnswerAttachment,
    IChecklist2ReportAnswer,
} from '../shared/fi-checklist2-report';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class FiChecklist2ReportService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getReportContainer(auditMode: boolean) {
        const url = `Checklist/Checklist2Report/GetReportContainer?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklist2ReportContainer>(url));
    }

    saveReportParameter(reportParameter: IChecklistV2ReportParameter, auditMode: boolean) {
        const url = `Checklist/Checklist2Report/SaveReportParameter?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<number>(url, reportParameter));
    }

    deleteReportParameters(reportParameterIds: number[], auditMode: boolean) {
        const url = `Checklist/Checklist2Report/DeleteReportParameters?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<void>(url, reportParameterIds));
    }

    getDataForReportParameter(reportParam: IChecklistV2ReportParameter, auditMode: boolean) {
        const url = `Checklist/Checklist2Report/GetDataForReportParameter?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<IChecklist2ReportData>(url, reportParam));
    }

    getChecklistAttachmentsListData(parameter: IChecklist2ReportAttachmentParameter) {
        const url = `Checklist/Checklist2Report/GetChecklistAttachmentsListData`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IItemsListDataFetchResult<ICheckpoint2AnswerAttachment>>(url, parameter),
        );
    }

    getChecklistAnswerDetailsByAnswerIds(answerIds: number[], auditMode: boolean) {
        const url = `Checklist/Checklist2Report/GetChecklistAnswerDetailsByAnswerIds?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<IChecklist2ReportAnswer[]>(url, answerIds));
    }
}
